import React from 'react'
import gql from 'graphql-tag'
import { compose, lifecycle, withHandlers } from 'recompose'
import { graphql } from 'react-apollo'
import { initializeFB } from '../../modules/facebook/facebookLogin'
import FacebookLoginButton from '../../modules/facebook/FacebookLoginButton'
import { setToken } from '../../modules/auth/auth'
import config from '../../config'
import appIcon from '../../images/icon-128.png'
import { Footer, FooterContent } from '../templates/login/Footer'
import { LoginSection, LoginMain } from '../templates/login/LoginLayout'
import LoginAppLogo from '../templates/login/LoginAppLogo'
import LoginCard, { LoginCardContainer } from '../templates/login/LoginCard'

const authenticateUser = gql`
  mutation AuthenticateUserMutation($facebookToken: String!) {
    authenticateUser(facebookToken: $facebookToken) {
      token
    }
  }
`

const LoginPage = props => (
  <LoginSection>
    <LoginMain>
      <LoginCardContainer>
        <LoginCard>
          <div className="card-content">
            <div className="content">
              <div className="has-text-centered">
                <LoginAppLogo src={appIcon} />

                <div>
                  <FacebookLoginButton />
                </div>
              </div>
            </div>
          </div>
        </LoginCard>
      </LoginCardContainer>
    </LoginMain>

    <Footer>
      <FooterContent>
        <div className="content has-text-centered">
          <div className="level">
            <div className="level-left">
              <small>
                <strong>Biru Moment</strong> by Poldet Assanangkornchai |{' '}
                <a href="https://twitter.com/beerpoldet">@beerpoldet</a>
              </small>
            </div>
            <div className="level-right">
              <small>
                <strong>@2018 ASSANEE</strong>
              </small>
            </div>
          </div>
        </div>
      </FooterContent>
    </Footer>
  </LoginSection>
)

export default compose(
  graphql(authenticateUser, { name: 'authenticateUser' }),
  withHandlers({
    handleFacebookLoginStatus: ({ authenticateUser }) => facebookResponse => {
      if (
        facebookResponse.status === 'connected' &&
        facebookResponse.authResponse &&
        facebookResponse.authResponse.accessToken
      ) {
        const facebookToken = facebookResponse.authResponse.accessToken
        authenticateUser({ variables: { facebookToken } })
          .then(({ data }) => {
            const { token } = data.authenticateUser
            setToken(token)
            window.location.reload()
          })
          .catch(e => {
            console.error(e)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      initializeFB(config.facebook, this.props.handleFacebookLoginStatus)
    },
  }),
)(LoginPage)



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.js